var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#6E6E6F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.88859 11.2538C9.90435 10.6987 10.1407 10.3622 10.6921 9.8912C11.212 9.47064 11.6531 9.03325 12.0313 8.56223C12.4094 8.0912 12.5984 7.50241 12.5984 6.79587C12.5984 5.9211 12.2991 5.1641 11.7004 4.54167C11.1017 3.91924 10.2194 3.59961 9.05358 3.59961C7.96649 3.59961 7.08421 3.93606 6.40675 4.59213C5.72929 5.24821 5.39844 6.1398 5.39844 7.25008C5.39844 7.5697 5.4457 7.90615 5.50872 8.2426L7.44658 8.32671C7.38356 8.04073 7.33629 7.75475 7.33629 7.40148C7.33629 6.19026 7.90347 5.36596 9.03782 5.36596C10.0304 5.36596 10.5188 6.05568 10.5188 6.87998C10.5188 7.40148 10.377 7.80522 10.1092 8.10802C9.84133 8.41082 9.52623 8.71363 9.17962 8.99961C8.40763 9.65568 8.09253 10.3622 8.07677 11.2538H9.88859ZM7.90347 14.3996H9.99887V12.1454H7.90347V14.3996Z",
    fill: "currentcolor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question_mark.6ab70ad4.svg";
export { ForwardRef as ReactComponent };